export enum RESERVATION_SEARCH_MODE {
  bookingReference = 'BOOKING_REFERENCE',
  checkinEmail = 'CHECKIN_EMAIL',
  both = 'BOTH',
}

export enum RESERVATION_NOT_FOUND_BEHAVIOR {
  create = 'CREATE_IF_NOT_FOUND',
  doNotCreate = 'DO_NOT_CREATE_IF_NOT_FOUND',
}
